import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import ThreeDots from "static/images/ThreeDots.svg";
import { Person } from "types/Models/apAutofills";

export const PersonRowAction = ({
  person,
  onViewDetails,
  onEdit,
}: {
  person: Person;
  onViewDetails: (person: Person) => void;
  onEdit: (person: Person) => void;
}) => {
  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <img
          src={ThreeDots}
          alt="options"
          onClick={(event) => event.stopPropagation()}
        />
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content
          sideOffset={6}
          align="end"
          onClick={(event) => event.stopPropagation()}
        >
          <Dropdown.Item
            key="view"
            onSelect={() => setTimeout(() => onViewDetails(person), 0)}
          >
            View details
          </Dropdown.Item>
          <Dropdown.Item
            key="edit"
            onSelect={() => setTimeout(() => onEdit(person), 0)}
          >
            Edit
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
